import { graphql, useStaticQuery } from "gatsby";
import { ImageDataLike } from "gatsby-plugin-image";

export type Props = {
  allPortalBuyer: {
    nodes: {
      url: string;
      title: string;
      slug: string;
      published_at: string;
      language: string;
      description: string;
      image_url: string;
      image: {
        childImageSharp: {
          gatsbyImageData: ImageDataLike;
        };
      };
    }[];
  };
};

export const useBuyerData = () => {
  const { allPortalBuyer }: Props = useStaticQuery(
    graphql`
      {
        allPortalBuyer(filter: { id: { ne: "dummy" } }) {
          nodes {
            url
            title
            slug
            published_at
            description
            language
            image_url
            image {
              childImageSharp {
                gatsbyImageData(
                  placeholder: BLURRED
                  width: 2000
                  formats: [AUTO, WEBP]
                  layout: FULL_WIDTH
                )
              }
            }
          }
        }
      }
    `
  );
  return allPortalBuyer.nodes;
};
